import React from 'react';
import {
  CBadge,
  CCol,
  CContainer,
  CForm,
  CRow,
} from "@coreui/react";

function MultipleChoice({
  type,
  num,
  question,
  score,
  data = [],  // Default to an empty array
  onAnswerChange,
  questionID,
  questionTypeID,
  isCorrect,
  isQuestionsFetched,
  currentPage

}) {
  const handleSelectAnswer = (option) => {
    onAnswerChange(questionID, questionTypeID, option);
  };

  const getIcon = (option) => {
    // If the answer is correct, display a checkmark
    if (isCorrect === 1 && option.userAnswer) {
      return <span style={{ color: '#28a745', marginLeft: '5px' }}>✔️</span>; // Green checkmark
    }
    // If the answer is incorrect and it was selected by the user, display a red cross
    if (isCorrect === 0 && option.correctAnswer) {
      return <span style={{ color: '#dc3545', marginLeft: '5px' }}>✔️</span>; // Green checkmark
    }
    if (isCorrect === 0 && option.userAnswer) {
      return <span style={{ color: '#dc3545', marginLeft: '5px' }}>❌</span>; // Red cross
    }
    return null;
  };
  const isDisabled = type === "review";
  return (
    <CContainer className="mb-3 questionContainer">
      <ol>
        <CRow className="justify-content-between">
          <CCol>
            <div>
                <span>
                  <span style={{ fontWeight: '650' }}>{`Q${isQuestionsFetched ? currentPage : num + 1})`}</span>{' '}
                  <span style={{ fontWeight: '650' }}>
                    {question}
                  </span>
                </span>
              <CForm>
                <ul>
                  <CRow xs={{ gutterY: 2 }}>
                    {data.map((option) => (
                      <CCol xs={6} lg={5} key={option.optionId}> {/* Adjusted for consistent spacing */}
                        <div className="d-flex align-items-center">
                          <input
                            // disabled={type === "3" ? false : true}
                            disabled={isDisabled}
                            className="form-check-input options"
                            type="radio"
                            name={`flexRadioDefault${questionID}`}
                            id={option.optionId}
                            value={option.optionValue}
                            onChange={() => handleSelectAnswer(option.optionId)}
                          />
                          <label
                            className="optionText"
                            style={{ marginLeft: "4px" }}
                            htmlFor={option.optionId}
                          >
                            {option.optionValue}
                          </label>
                          {getIcon(option)} {/* Show the checkmark or cross */}
                        </div>
                      </CCol>
                    ))}
                  </CRow>
                </ul>
              </CForm>
            </div>
          </CCol>
          <CCol className="align-self-start" xs={2} md={1}>
            <div className="text-center">
              <h2>
                <CBadge title="Score per question" shape="rounded-pill" color="primary">
                  {score}
                </CBadge>
              </h2>
            </div>
          </CCol>
        </CRow>
      </ol>
    </CContainer>
  );
}

export default MultipleChoice;
